var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWorkshopBackdrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_mask",
    "data-name": "Rectangle mask",
    width: 1920,
    height: 1080,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92bacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#8eb5c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683,
    stopColor: "#82a9ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#749aa8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-workshopBackdrop",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-000009999",
    transform: "translate(0.629 -0.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5843",
    "data-name": "Rectangle 5843",
    width: 1920,
    height: 338.916,
    transform: "translate(-0.629 743.366)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5844",
    "data-name": "Rectangle 5844",
    width: 1920,
    height: 226.744,
    transform: "translate(-0.629 516.622)",
    fill: "#185260",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 1920,
    transform: "translate(-0.629 797.772)",
    fill: "none",
    stroke: "#749aa8",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 1920,
    transform: "translate(-0.629 758.056)",
    fill: "none",
    stroke: "#749aa8",
    strokeMiterlimit: 10,
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 1920,
    transform: "translate(-0.629 853.697)",
    fill: "none",
    stroke: "#749aa8",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 1920,
    y2: 0.016,
    transform: "translate(-0.629 938.766)",
    fill: "none",
    stroke: "#749aa8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "top-pipe",
    transform: "translate(-0.108 58.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6082",
    "data-name": "Rectangle 6082",
    width: 1919.479,
    height: 54.093,
    fill: "#9ab3cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6083",
    "data-name": "Rectangle 6083",
    width: 1919.479,
    height: 20.389,
    transform: "translate(0 33.703)",
    fill: "#8aa0ba"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6084",
    "data-name": "Rectangle 6084",
    width: 1919.479,
    height: 8.572,
    transform: "translate(0 6.676)",
    fill: "#bad5e8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWorkshopBackdrop);
export default __webpack_public_path__ + "static/media/background-workshopBackdrop.95ea4c73.svg";
export { ForwardRef as ReactComponent };